import { configureStore } from '@reduxjs/toolkit'
import windowReducer from './slices/windowSlice'
import authReducer from './slices/authSlice'
import notificationsReducer from './slices/notificationsSlice'
import internalChatReducer from './slices/internalChatSlice'
import shortcutsReducer from './slices/shortcutsSlice'
import hospitalContextReducer from './slices/hospitalContextSlice'

export const store = configureStore({
    reducer: {
        window: windowReducer,
        auth: authReducer,
        notifications: notificationsReducer,
        internalChat: internalChatReducer,
        shortcuts: shortcutsReducer,
        hospitalContext: hospitalContextReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
